var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import figlet from 'figlet';
import standard from 'figlet/importable-fonts/Standard';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import objectSupport from 'dayjs/plugin/objectSupport';
import duration from 'dayjs/plugin/duration';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import LibPhoneNumber from 'google-libphonenumber';
dayjs.extend(utc);
dayjs.extend(objectSupport);
dayjs.extend(duration);
dayjs.extend(customParseFormat);
export var deepCopy = function (target, map) {
    if (map === void 0) { map = new WeakMap(); }
    if (target !== null && typeof target === 'object') {
        var cloneTarget = Array.isArray(target) ? [] : {};
        // avoid circle reference
        if (map.get(target))
            return target;
        map.set(target, cloneTarget);
        for (var key in target) {
            cloneTarget[key] = deepCopy(target[key], map);
        }
        return cloneTarget;
    }
    return target;
};
// 底線 -> 小駝峰
export var toCamel = function (data) {
    if (typeof data != 'object' || !data)
        return data;
    if (Array.isArray(data))
        return data.map(function (item) { return toCamel(item); });
    var newData = {};
    for (var key in data) {
        var newKey = key.replace(/_([0-9a-z])/g, function (p, m) { return m.toUpperCase(); });
        newData[newKey] = toCamel(data[key]);
    }
    return newData;
};
// 小駝峰 -> 底線
export var toUnderline = function (data) {
    if (typeof data != 'object' || !data)
        return data;
    if (Array.isArray(data))
        return data.map(function (item) { return toUnderline(item); });
    var newData = {};
    for (var key in data) {
        var newKey = key.replace(/([A-Z])/g, function (p, m) { return "_".concat(m.toLowerCase()); });
        newData[newKey] = toUnderline(data[key]);
    }
    return newData;
};
export var consoleProject = function () {
    var _a;
    var PROJECT_NAME = 'SoFinX';
    var VERSION = ((_a = document.getElementsByName('version')[0]) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) || '';
    figlet.parseFont('Standard', standard);
    figlet.text(PROJECT_NAME, { font: 'Standard' }, function (err, data) { return console.log("%c".concat(data), 'color: #14BDBD'); });
    console.log("%c ".concat(VERSION, " "), 'color: #bada55');
};
export var isDev = function (host) {
    return process.env.NODE_ENV === 'development' || document.domain === host;
};
// 格式化時間 (收到UTC格式 自動轉 本地時區)
export var timeFormat = function (timeForm) {
    if (timeForm === void 0) { timeForm = {}; }
    var value = timeForm.value, _a = timeForm.to, to = _a === void 0 ? 'YYYY/MM/DD HH:mm:ss' : _a;
    if (!value || !dayjs(value).isValid())
        return '';
    return dayjs(value).format(to);
};
// 本地時區 轉 UTC
export var toUTCFormat = function (timeForm) {
    if (timeForm === void 0) { timeForm = {}; }
    var value = timeForm.value, _a = timeForm.to, to = _a === void 0 ? 'YYYY/MM/DD HH:mm:ss' : _a, from = timeForm.from;
    if (!value || !dayjs(value, from).isValid())
        return '';
    return dayjs(value, from).utc().format(to);
};
// UTC 轉 本地時區 (解決value非UTC格式的情況, UTC格式: 2022-06-06T09:06:36.690671Z, 非UTC格式 12:00:00)
export var toLocalFormat = function (timeForm) {
    if (timeForm === void 0) { timeForm = {}; }
    var value = timeForm.value, _a = timeForm.to, to = _a === void 0 ? 'YYYY/MM/DD HH:mm:ss' : _a, from = timeForm.from;
    if (!value || !dayjs(value, from).isValid())
        return '';
    return dayjs.utc(value, from).local().format(to);
};
// 取得時間戳
export var toTimeStamp = function (value) { return dayjs(value).valueOf() || 0; };
// 取得時區
export var GetTimeZone = function () {
    var timezone = -(new Date().getTimezoneOffset() / 60);
    return timezone >= 0 ? "+".concat(timezone) : "".concat(timezone);
};
// 秒數轉時長
export var toDuration = function (timeForm) {
    var _a;
    var value = timeForm.value, _b = timeForm.to, to = _b === void 0 ? 'YMDHm' : _b;
    var temp = Number(value);
    var timeStr = '';
    // 取得顯示字串
    var getLabel = function (n, unit) { return "".concat(n).concat(unit); };
    var timeMap = {
        year: {
            unit: 'Y',
            second: 60 * 60 * 24 * 30 * 12,
            value: 0,
            enabled: to.indexOf('Y') > -1
        },
        month: {
            unit: 'M',
            second: 60 * 60 * 24 * 30,
            value: 0,
            enabled: to.indexOf('M') > -1
        },
        day: {
            unit: 'D',
            second: 60 * 60 * 24,
            value: 0,
            enabled: to.indexOf('D') > -1
        },
        hour: {
            unit: 'H',
            second: 60 * 60,
            value: 0,
            enabled: to.indexOf('H') > -1
        },
        minute: {
            unit: 'm',
            second: 60,
            value: 0,
            enabled: to.indexOf('m') > -1
        },
    };
    if (!Number.isNaN(value)) {
        Object.values(timeMap).forEach(function (item) {
            if (item.enabled) {
                item.value = Math.floor(temp / item.second);
                // 剩餘時間
                temp = temp % item.second;
                // 時間字串
                if (item.value > 0)
                    timeStr += getLabel(item.value, item.unit);
            }
        });
    }
    // 組成時間物件
    var timeObj = {};
    Object.keys(timeMap).forEach(function (key) {
        timeObj[key] = timeMap[key].value;
    });
    // 若顯示字串為空，設為 <1最小單位時間
    if (!timeStr) {
        var minUnitLabel = ((_a = Object.values(timeMap).reverse().find(function (item) { return item.enabled; })) === null || _a === void 0 ? void 0 : _a.unit) || '';
        timeStr = "<1".concat(minUnitLabel);
    }
    return __assign(__assign({}, timeObj), { timeStr: timeStr });
};
// 數字轉百分比
export var toPercent = function (value, fixed, sign) {
    if (fixed === void 0) { fixed = 2; }
    if (sign === void 0) { sign = '%'; }
    var result = Number(value);
    if (!result && result !== 0)
        return "-".concat(sign);
    return "".concat((result * 100).toFixed(fixed)).concat(sign);
};
// 轉千分位
export var toAmount = function (value, fixed, sign, mantissa) {
    if (fixed === void 0) { fixed = 2; }
    if (sign === void 0) { sign = '$'; }
    if (mantissa === void 0) { mantissa = 'round'; }
    var result = Number(value);
    if (!result && result !== 0)
        return "".concat(sign, "-");
    /// 無條件捨去
    if (mantissa === 'floor') {
        result = Math.floor(result * Math.pow(10, fixed)) / Math.pow(10, fixed);
    }
    /// 無條件進位
    else if (mantissa === 'ceil') {
        result = Math.ceil(result * Math.pow(10, fixed)) / Math.pow(10, fixed);
    }
    var strSplit = String(result.toFixed(fixed)).split('.');
    var int = strSplit[0]; //取整數位
    var decimel = strSplit[1]; // 取小數位
    return "".concat(sign).concat(int.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).concat(decimel ? '.' + decimel : '');
};
// 轉千分位(input使用)
export var stringToAmount = function (value, sign) {
    if (sign === void 0) { sign = ''; }
    value = String(value);
    if (!+value && +value !== 0)
        return '';
    if (+value < 0) {
        value = (-value).toString();
        var parts = value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (parts.length > 1) {
            parts[1] = parts[1].slice(0, 2);
        }
        return "-".concat(sign).concat(parts.join('.'));
    }
    else {
        value = value.toString();
        var parts = value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (parts.length > 1) {
            parts[1] = parts[1].slice(0, 2);
        }
        return "".concat(sign).concat(parts.join('.'));
    }
};
// 取消千分位
export var amountToString = function (value) {
    return value.replaceAll(',', '');
};
// 計算百分比
export var computePercent = function (profit, principal, percent) {
    if (percent === void 0) { percent = false; }
    var part = Number(profit) || 0;
    var total = Number(principal) || 0;
    return (((part / total) || 0) * 100).toFixed(2) + (percent ? '%' : '');
};
// 國碼+電話 轉成 手機號碼
export var parsePhoneNumber = function (phone, country) {
    var PhoneNumberUtil = LibPhoneNumber.PhoneNumberUtil.getInstance();
    try {
        var res = PhoneNumberUtil.parse(phone, country);
        return "+".concat(res.getCountryCode()).concat(res.getNationalNumber());
    }
    catch (_a) {
        isDev() && console.log('phone parse error');
        return '';
    }
};
// 是否為有效的手機號碼
export var isPhoneNumberValid = function (phone, countryCode) {
    var PhoneNumberUtil = LibPhoneNumber.PhoneNumberUtil.getInstance();
    var isValid = false;
    try {
        isValid = PhoneNumberUtil.isValidNumber(PhoneNumberUtil.parse(phone, countryCode));
    }
    catch (_a) {
        isValid = false;
    }
    return isValid;
};
export var onErrorEvent = function () {
    window.addEventListener('error', function (errorEvent) {
        var _a, _b, _c;
        isDev() && errorEvent.message !== undefined && console.log(errorEvent.message);
        var isProd = /^.*\.sofinx.com$/.test(window.location.host);
        if (isProd && errorEvent.message !== undefined) {
            var VERSION = ((_a = document.getElementsByName('version')[0]) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) || '-';
            var PROJECT = process.env.REACT_APP_PROJECT || '-';
            var broker = window.location.host.split('.')[0] || '-';
            var body = {
                domain: window.location.host,
                project: PROJECT,
                broker: broker,
                name: errorEvent.message.split(':')[0] || '-',
                message: ((_b = errorEvent.error) === null || _b === void 0 ? void 0 : _b.message) || '-',
                stack: ((_c = errorEvent.error) === null || _c === void 0 ? void 0 : _c.stack) || '-',
                cause: '-',
                time: dayjs().utc().format(),
                version: VERSION,
            };
            fetch('https://user-data-collection.sofinx.otso-dev.com/error_records', { method: 'POST', body: JSON.stringify(body) });
        }
    }, true);
};
// 效能監控
export var performanceTiming = function () {
    setTimeout(function () {
        var timing = performance.timing;
        console.log('總加載時間:', ((timing.domComplete - timing.fetchStart) / 1000), '秒');
        console.log('DNS解析時間:', ((timing.domainLookupEnd - timing.domainLookupStart) / 1000), '秒');
        console.log('HTTP連接時間:', ((timing.connectEnd - timing.connectStart) / 1000), '秒');
        console.log('網頁請求時間:', ((timing.responseEnd - timing.requestStart) / 1000), '秒');
        console.log('DOM渲染時間:', ((timing.domInteractive - timing.domLoading) / 1000), '秒');
        console.log('網頁資源加載時間:', ((timing.domContentLoadedEventEnd - timing.domContentLoadedEventStart) / 1000), '秒');
    }, 1500);
};
// 省略小數點後多餘0
export var ellipsisZero = function (value) {
    if (value === 0 || value === '0')
        return value;
    var arr = value.toString().split('.');
    if (arr[1])
        arr[1] = arr[1].replace(/0+$/, '');
    return "".concat(arr[0]).concat(arr[1] ? '.' + arr[1] : '');
};
export var hexToRgba = function (hex, opacity) {
    // 去掉前面的#字符
    hex = hex.replace(/^#/, '');
    var r = parseInt(hex.slice(0, 2), 16);
    var g = parseInt(hex.slice(2, 4), 16);
    var b = parseInt(hex.slice(4, 6), 16);
    var rgba = "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
    return rgba;
};
